export default "__VITE_ASSET__Lc6Zthiq__"